export default class Default {
  constructor(_main) {

    Vue.component('slideshow', {
      props: ['slides','dimensions','selected'],
      mounted: function() {
        //Preload slides
        var preload = _main.utils.preload;
        var images = [
          ..._.map(this.slides, (v) => this.showImage(v.url)),
          ..._.map(this.slides, (v) => this.showImage(v.url, '300x'))
        ];

        preload.files({
          src: images,
          callback: () => {

          }
        });

        //Handle swiping
        var sliderEl = this.$refs.sliderSwipe;
        var hm = new Hammer(sliderEl);

        hm.on('swipeleft', (ev) => {
          this.nextSlide();
        });

        hm.on('swiperight', (ev) => {
          this.prevSlide();
        });
      },
      methods: {
        setSlide: function(select) {
          this.$emit('update:selected', select);
        },
        nextSlide: function() {
          var select = (this.selected + 1 >= this.slides.length) ? 0 : this.selected + 1;
          this.$emit('update:selected', select);
        },
        prevSlide: function() {
          var select = (this.selected - 1 < 0) ? this.slides.length - 1 : this.selected - 1;
          this.$emit('update:selected', select);
        },
        showImage: (url, dimensions='800x') => {
          //Split url by '.'
          var dot_pos = (~-url.lastIndexOf(".") >>> 0) + 1;
          // Insert format in string
          return [url.slice(0,dot_pos), `_${dimensions}`, url.slice(dot_pos)].join('');
        },
        isVideo: (slide) => {
          return slide.alt.indexOf('vimeo.com') > -1
        },
        showVideo: (slide) => {
          var id = slide.alt
            .replace('https:','')
            .replace(/\//g,'')
            .replace('vimeo','')
            .replace('.com','');

            console.log(id);

          var src = `https://player.vimeo.com/video/${id}?autoplay=0&loop=1&autopause=0`;

          return `<iframe src="${src}" frameborder="0" width="1450" height="1933"></iframe>`;
        },
        setOverlay: function() {
          console.log(this);
          this.$emit('update:overlay', 'gallery');
        },
        showSlideshowClass: (slides) => {
          return (slides.length > 1) ? '' : 'slideshow-single';
        }
      },
      template: `
        <div class="slideshow" v-bind:class="showSlideshowClass(slides)">
          <div class="slides">
            <div class="controls">
              <div class="touch" ref="sliderSwipe"></div>
              <div class="prev" v-on:click="prevSlide()"></div>
              <div class="next" v-on:click="nextSlide()"></div>
              <!--
              <div class="overlay" v-on:click="setOverlay()"></div>
              -->
            </div>
            <transition name="fade">
              <div class="slide" v-for="(slide, slide_idx) in slides" v-bind:key="slide_idx" v-if="slide_idx == selected" v-bind:style="{'background-image': 'url(' + showImage(slide.url) + ')'}" >
                <div class="video" v-if="isVideo(slide)" v-html="showVideo(slide)"></div>
              </div>
            </transition>
          </div>
          <div class="pager">
            <!--<nav class="overlay" v-on:click="setOverlay()"><span>+</span></nav>-->
            <nav >
              <ul>
                <li v-for="(slide, slide_idx) in slides"  v-on:click="setSlide(slide_idx)" v-bind:class="{active: slide_idx == selected}">
                  <span><em v-text="slide_idx + 1"></em></span>
                  <div class="image"><img v-bind:src="showImage(slide.url, '300x')" /></div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      `
    });
  }
} 